var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DashboardLayout',[_c('ReversalBody',{attrs:{"reversals":_vm.externalReversals,"grandTotalReversal":'[null]',"totalCurrentMonthReversal":'[null]',"loading":_vm.loading}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }